import React, {useEffect, useState} from 'react';
import {Skeleton} from '@material-ui/lab';
import {reduxToggleSidePanel} from 'appredux/actions';
import {SoilDataForm} from 'components/SoilDataForm/SoilDataForm'; // <— Make sure this path is correct
import {ISoilData} from 'components/SoilDataForm/SoilDataForm'; // The interface for your soil data

export default function AddOrUpdateSoilData(props: {
  soilData?: ISoilData; // existing soil data if editing
  readOnly?: boolean; // if true, display in view-only mode
}) {
  // If no soilData is passed, assume we are "adding"
  const [soilData] = useState<ISoilData | undefined>(props.soilData);
  const [isLoading] = useState<boolean>(false);
  const readOnly = props.readOnly ?? false;

  // Debug log to verify readOnly is being passed
  React.useEffect(() => {
    console.log(
      'AddOrUpdateSoilData - readOnly:',
      readOnly,
      'props.readOnly:',
      props.readOnly,
    );
  }, [readOnly, props.readOnly]);

  // If you need to load references or some lookup data, do it here.
  // For example, if you needed a server call:
  useEffect(() => {
    // If no external data needed, skip this
    // setIsLoading(true);
    // someApiCall()
    //   .then(...)
    //   .finally(() => setIsLoading(false));
  }, []);

  // The callback for SoilDataForm submission
  const onSubmitSoilData = (submission: ISoilData) => {
    // 1. Save soil data in Redux or your store
    // e.g. reduxSetSoilData(submission);
    console.log('Soil data submitted:', submission);

    // 2. Close the side panel
    reduxToggleSidePanel(false, null);

    // 3. Optionally navigate or do anything else
    // e.g. NavigationService.navigate('/some-route');
  };

  // If data is loading, show a skeleton
  if (isLoading) {
    return (
      <div style={{padding: '1rem'}}>
        <Skeleton variant="rect" height={600} />
      </div>
    );
  }

  return (
    <SoilDataForm
      initialSoilData={soilData}
      onSubmit={onSubmitSoilData}
      onCancel={() => reduxToggleSidePanel(false, null)}
      readOnly={readOnly}
    />
  );
}
